var i18n = (function(){
"use strict";
	var db = {};
	var enableEmit = true;
	// Mapping from pluralization group plural logic.
	var pluralTypes = {
		arabic: function (n) {
			// http://www.arabeyes.org/Plural_Forms
			if (n < 3) { return n; }
			if (n % 100 >= 3 && n % 100 <= 10) return 3;
			return n % 100 >= 11 ? 4 : 5;
		},
		chinese: function () { return 0; },
		german: function (n) { return n !== 1 ? 1 : 0; },
		french: function (n) { return n > 1 ? 1 : 0; },
		russian: function (n) {
			if (n % 10 === 1 && n % 100 !== 11) { return 0; }
			return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
		},
		czech: function (n) {
			if (n === 1) { return 0; }
			return (n >= 2 && n <= 4) ? 1 : 2;
		},
		polish: function (n) {
			if (n === 1) { return 0; }
			return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
		},
		icelandic: function (n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; }
	}
	// Mapping from pluralization group to individual locales.
	, pluralTypeToLanguages = {
		arabic: ['ar'],
		chinese: ['id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
		german: ['fa', 'da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
		french: ['fr', 'tl', 'pt-br'],
		russian: ['hr', 'ru', 'lt'],
		czech: ['cs', 'sk'],
		polish: ['pl'],
		icelandic: ['is']
	}
	, langToTypeMap = function(mapping) {
		var ret = {};
		Object.keys(mapping).forEach(function(type) {
			this[type].forEach(function(lang) {
				ret[lang] = type;
			});
		}, mapping);
		return ret;
	}
	, pluralTypeName = function(locale) {
		var langToPluralType = langToTypeMap(pluralTypeToLanguages);
		return langToPluralType[locale]
			|| langToPluralType[locale.split(/-/, 1)[0]]
			|| langToPluralType.en;
	}
	, pluralTypeIndex = function(locale, count) {
		return pluralTypes[pluralTypeName(locale)](count);
	}
	, db = JSON.parse($.ajax({
		url: $('link[rel="localization"]').attr('href'),
		cache: false,
		async: false,
		dataType: "json"
	}).responseText) || {}
	, t = function(){
		var msg;
		if(db[arguments[0]]){
			msg = db[arguments[0]];
			if(typeof msg !== "string"){ // plural
				msg = msg[pluralTypeIndex(document.documentElement.lang, arguments[1])];
			}
		}
		else{
			// not found in dictionary
			msg = arguments[0];
			if(enableEmit){
				// send an untranslatable string
				var params = Array.prototype.slice.call(arguments);
				socket.emit("i18n",{ data: params });
				$.ajax({url:'/php/i18n.php', type:'post', dataType:'json', contentType:'application/json', scriptCharset:'utf-8', data:JSON.stringify(params)});
			}
			if(USEROPTS.debug){
			    console.log("not i18n: "+msg);
			}
		}
		// replace %s
		for(var i=1; i<arguments.length; i++){
			if(typeof arguments[i] !== "object"){
				msg = msg.replace(/%s/, arguments[i]);
			}
		}
		// replace {{{name}}}
		if((1 < arguments.length) && (typeof arguments[arguments.length-1] === "object")){
			var obj = arguments[arguments.length-1];
			Object.keys(obj).forEach(function (key) {
				var re = new RegExp("{{{"+key+"}}}","g");
				msg = msg.replace(re,obj[key]);
			});
		}
		return msg;
	}
	, disableEmit = function(){
		console.log("i18n disableEmit");
		enableEmit = false;
	}
	, load = function(url){
		var append = JSON.parse($.ajax({
			url: url,
			cache: false,
			async: false,
			dataType: "json"
		}).responseText) || {};
		Object.assign(db,append);
	};
	return { t: t, load: load, disableEmit: disableEmit };
}());
function __(){
	return i18n.t.apply(this,arguments);
}
